import { render } from "./AdminStudentAssigment.vue?vue&type=template&id=f8f8b132&scoped=true"
import script from "./AdminStudentAssigment.vue?vue&type=script&lang=js"
export * from "./AdminStudentAssigment.vue?vue&type=script&lang=js"

import "./AdminStudentAssigment.vue?vue&type=style&index=0&id=f8f8b132&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\City Hoardings\\City_Hoardings_UI\\ui-admin-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8f8b132"]])

export default __exports__